import { render, staticRenderFns } from "./topicDetail.vue?vue&type=template&id=06bdf64e&scoped=true&"
import script from "./topicDetail.vue?vue&type=script&lang=js&"
export * from "./topicDetail.vue?vue&type=script&lang=js&"
import style0 from "./topicDetail.vue?vue&type=style&index=0&id=06bdf64e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bdf64e",
  null
  
)

export default component.exports